// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a big_wx big_jb big_xl big_i big_j big_q big_vt big_et big_so big_sp big_eg","CommentsButton__icon":"il_b big_rz"};